import Seo from '@components/seo'
import { normalizedData } from '@utils'

export const Head = ({ data, location, pageContext }) => {
  const seo = data?.strapiTemplatedPage?.seo || data?.strapiPage?.seo || {}
  const locale = pageContext?.locale || 'de'
  const content = normalizedData(
    data?.strapiTemplatedPage?.content || data?.strapiPage?.content || []
  )

  return (
    <Seo
      {...seo}
      fallbackImage={content?.['header-section']?.images?.[0]}
      pathname={location.pathname}
      lang={locale}
      noindex={pageContext?.noindex || false}
    />
  )
}
